import Link from 'next/link';
import logger from '../../../../lib/logger'
import AppLogo from '../../apps/logo'

import { 
  CurrencyDollarIcon, 
  ArrowsRightLeftIcon, 
  CogIcon, 
  Bars4Icon, 
  QuestionMarkCircleIcon, 
  BuildingOfficeIcon,
  ChartBarIcon, 
  RectangleStackIcon
} from '@heroicons/react/24/outline';


export default function ComparisonBlockTitle({ name='', title='', href='', iconName}) {
  logger.info("Component.ComparisonBlockTitle rendering.");

  if (!name) return <></>

  const icons = [
    { name: "CurrencyDollarIcon", icon: CurrencyDollarIcon },
    { name: "ArrowsRightLeftIcon", icon: ArrowsRightLeftIcon },
    { name: "CogIcon", icon: CogIcon },
    { name: "Bars4Icon", icon: Bars4Icon },
    { name: "QuestionMarkCircleIcon", icon: QuestionMarkCircleIcon },
    { name: "BuildingOfficeIcon", icon: BuildingOfficeIcon },
    { name: "ChartBarIcon", icon: ChartBarIcon },
    { name: "RectangleStackIcon", icon: RectangleStackIcon },
  ]

  return (
    <>
      <div id={href} className="pt-8 -mt-8 h-0"/>

      <div className="flex items-center">

        <div className="flex-shrink-0">
          {icons.filter(x => x.name === iconName).map((item, idx) => (
            <item.icon key={idx} className="h-8 w-8 text-gray-400" aria-hidden="true" />
          ))}          
        </div>

        <div className="flex-1 ml-2">
          <h2 className="text-3xl font-semibold tracking-tight text-gray-900">
            {name}
          </h2>
        </div>
      </div>
      
      {title && (
        <div className="py-2">
          <p className="text-base text-gray-500">
            {title}
          </p>
        </div>
      )}

      {/* Subtitle */}


    </>
  )
}
